import React, {Component} from 'react'

class NoBaskets extends Component {
    render() {
        return (
            <tr className='NoBaskets'>
                <td colSpan={20}><i>Chưa có giỏ nào</i></td>
            </tr>
        )
    }
}

export default NoBaskets
